/*
 *  Project: dux - color code
 *  Description: add a colored strip to an item
 *  Author: bwin
 */

;(function ( $, window, document, undefined ){

    var pluginName = 'dv_colorcode',
        defaults = {
            color: 'inherit',
            class: 'color-code'
        };

    function Plugin( element, options ){

        this.element = element;
        this.$element = $( element );

        this.options = $.extend( {}, defaults, options );

        this._defaults = defaults;
        this._name = pluginName;

        this.init();
    }

    $.extend( Plugin.prototype, {
        init: function (){

            var $this = this.$element,
                $colorCode = $( '<div/>' );

            $colorCode
                .addClass( this.options.class )
                .css( 'background-color', this.options.color )
                .prependTo( $this );

        }
    } );

    $.fn[ pluginName ] = function ( options ){
        var args = arguments;


        if ( typeof options === 'string' && options.slice(0,1) === '#') {

            options = {
                color: options
            };

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );
        } else if ( options === undefined || typeof options === 'object' ) {

            return this.each( function (){

                if ( !$.data( this, 'plugin_' + pluginName ) ) {
                    $.data( this, 'plugin_' + pluginName, new Plugin( this, options ) );
                }

            } );

        } else if ( typeof options === 'string' && options[ 0 ] !== '_' && options !== 'init' ) {

            var returns;

            this.each( function (){

                var instance = $.data( this, 'plugin_' + pluginName );

                if ( instance instanceof Plugin && typeof instance[ options ] === 'function' ) {
                    returns = instance[ options ].apply( instance, Array.prototype.slice.call( args, 1 ) );
                }

                if ( options === 'destroy' ) {
                    $.data( this, 'plugin_' + pluginName, null );
                }

            } );

            return returns !== undefined ? returns : this;
        }
    };

})( jQuery, window, document );
